import React from 'react';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import EventBusyOutlinedIcon from '@material-ui/icons/EventBusyOutlined';

import { StyledIconButton } from 'components/shared/MuiExtensions';
import Zone from 'components/shared/Zone';
import { formatTimezone, filteredHolidays } from 'utils/functions';
import { TeamHoliday } from 'typings';

dayjs.extend(timezone);

interface TeamHolidaysProps {
  holidays?: TeamHoliday[];
  timezone: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      pointerEvents: 'none',
    },
    gap: {
      minWidth: '200px',
    },
    holidays: {
      padding: theme.spacing(0, 1),
    },
  })
);

const TeamHolidays = ({ holidays, timezone }: TeamHolidaysProps) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const holidaysData = filteredHolidays(holidays, timezone);

  const teamHolidays = holidaysData?.map((holiday) =>
    holiday?.date ? (
      <div key={holiday.date} className="horizontal-space">
        <Typography variant="subtitle1" className={classes.holidays}>
          {holiday.date}
        </Typography>
        <Typography variant="body2" className={classes.holidays}>
          {holiday?.description ?? 'No Description'}
        </Typography>
      </div>
    ) : null
  );

  return (
    <div>
      <StyledIconButton
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        color="inherit"
      >
        <EventBusyOutlinedIcon />
      </StyledIconButton>
      <Popover
        id="mouse-over-popover"
        className={classes.popover}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Zone
          heading={
            <div className={`${classes.gap} horizontal-space`}>
              customer holidays
              {!!timezone && <span>{formatTimezone(timezone)}</span>}
            </div>
          }
        >
          {teamHolidays}
        </Zone>
      </Popover>
    </div>
  );
};

export default TeamHolidays;
